import { List, Paragraph } from '@zillow/constellation-10';
import type { ElementType } from 'react';

import { TextStyledComponent } from '../TextStyledComponent';
import type { TextStyledComponentProps } from '../../model/TextStyledComponent';

import { StyledListItem } from './styles';

const bodyTypeMap = {
  paragraph: Paragraph,
  unorderedList: List.Root,
  orderedList: List.Root,
  bareboneList: List.Root,
} as const;

const listTypeMap = {
  unorderedList: 'bullet',
  orderedList: 'number',
  bareboneList: 'none',
} as const;

type Props = {
  sentences: Array<Array<TextStyledComponentProps>>;
  type: keyof typeof bodyTypeMap | string;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

export const BodyStyledComponent = ({ sentences, type, csEventsHandler, csEventsIdMap }: Props) => {
  const DynamicBodyComponent: ElementType = bodyTypeMap[type as keyof typeof bodyTypeMap];
  const listProps = listTypeMap[type as keyof typeof listTypeMap]
    ? { appearance: listTypeMap[type as keyof typeof listTypeMap] }
    : false;
  const DynamicListItemComponent = listTypeMap[type as keyof typeof listTypeMap] !== undefined ? StyledListItem : null;

  return (
    <DynamicBodyComponent {...listProps}>
      {sentences.map((sentence, i) => {
        if (DynamicListItemComponent !== null) {
          return (
            <DynamicListItemComponent key={i}>
              {sentence.map((textComponent, i) => {
                return <TextStyledComponent key={i} styledComponentContent={textComponent} />;
              })}
            </DynamicListItemComponent>
          );
        } else {
          return sentence.map((textComponent, i) => {
            return (
              <TextStyledComponent
                key={i}
                styledComponentContent={textComponent}
                csEventsHandler={csEventsHandler}
                csEventsIdMap={csEventsIdMap}
              />
            );
          });
        }
      })}
    </DynamicBodyComponent>
  );
};
